/* eslint-disable func-style */
import { push } from 'react-router-redux'
import axios from 'axios'
import { call, put, select, takeLatest } from 'redux-saga/effects'

// Actions
import {
  COGNITO_LOGIN_ERROR,
  COGNITO_LOGIN_USER,
  ACCOUNT_LOGIN_LOAD,
  ACCOUNT_LOGOUT,
  UPDATE_COMPANY,
  ACCOUNT_FORGOT_PASSWORD_ATTEMPT
} from './actionTypes'
import {
  loginLoad,
  loginSuccess,
  loginReset,
  cognitoLoginError,
  setUser,
  forgotPasswordFailure,
  forgotPasswordSuccess,
  updateCompanySuccess,
  setPreferencesShowLoading,
  setPreferencesHideLoading
} from './actions'
import { getWagesByJurisdiction } from '../minWage/actions'
import { alertOpen } from '../common/actions'
import { getPosts, getUpdates } from '../compliance/actions'
import { hideLoading } from '../app/actions'

// Helpers
import { apiBasePath } from '../app/selectors'
import { checkCognitoSession, cognitoSignOut } from '../clients/userPool'
import companyService from '../services/companyService'

export function* cognitoLoginErrorSaga(error) {
  yield put(cognitoLoginError({ errorCode: error.code }))
  yield put(loginReset())
}

export function* cognitoLoginUserSaga(data) {
  if (!data.payload.company) {
    yield put(setUser(data.payload.user))
    global.sessionStorage.setItem('user', JSON.stringify(data.payload.user))
  } else {
    global.sessionStorage.setItem('user', JSON.stringify(data.payload.user))
    global.sessionStorage.setItem('company', JSON.stringify(data.payload.company))
    global.sessionStorage.setItem('email_banner', '')
    yield put(loginSuccess( null, data.payload.user, data.payload.company))
    yield put(loginLoad())
  }
}

export function* loginLoadSaga() {
  // Load all data from APis here
  yield put(getPosts())
  yield put(getUpdates())
  yield put(getWagesByJurisdiction())
  yield put(hideLoading())
}

export function* logoutSaga() {
  cognitoSignOut()
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('user')
  sessionStorage.removeItem('company')
  sessionStorage.removeItem('email_banner')
  window.location.assign('/')
}

export function* putCompanySaga(data) {
  yield put(setPreferencesShowLoading())
  try {
    yield companyService.putCompanySettings({
      companyId: data.payload._id,
      annualRevenue: data.payload.annualRevenue,
      employeeCount: data.payload.employeeCount,
      hasTippedEmployees: data.payload.hasTippedEmployees,
      industry: data.payload.industry
    })
    yield put(updateCompanySuccess(data.payload))
    yield put(setPreferencesHideLoading())
    yield put(
      alertOpen({
        type: 'success',
        message: 'Your Company Settings were successfully updated'
      })
    )
  } catch (e) {
    yield put(setPreferencesHideLoading())
    yield put(
      alertOpen({
        type: 'error',
        message: 'Your Company Settings failed to update'
      })
    )
  }
}

export function* forgotPasswordSaga(action) {
  try {
    yield call(axios, {
      data: action.payload,
      method: 'POST',
      responseType: 'json',
      baseURL: yield select(apiBasePath),
      url: '/reset-password'
    })
  } catch (e) {
    yield put(forgotPasswordFailure())
    return
  }
  yield put(forgotPasswordSuccess())
}

export default function* accountSaga() {
  yield takeLatest(COGNITO_LOGIN_USER, cognitoLoginUserSaga)
  yield takeLatest(COGNITO_LOGIN_ERROR, cognitoLoginErrorSaga)
  yield takeLatest(ACCOUNT_LOGIN_LOAD, loginLoadSaga)
  yield takeLatest(ACCOUNT_LOGOUT, logoutSaga)
  yield takeLatest(UPDATE_COMPANY, putCompanySaga)
  yield takeLatest(ACCOUNT_FORGOT_PASSWORD_ATTEMPT, forgotPasswordSaga)

  if (sessionStorage.getItem('token') || (checkCognitoSession() && sessionStorage.getItem('user') && sessionStorage.getItem('company'))) {
    const token = sessionStorage.getItem('token')
    const user = JSON.parse(sessionStorage.getItem('user'))
    const company = JSON.parse(sessionStorage.getItem('company'))
    yield put(setUser(user))
    yield put(loginSuccess(token, user, company))
    yield put(loginLoad())
  } else if (
    window.location.includes
    && !window.location.includes('/reset-password')
  ) {
    // Kick to login page if no token and not on reset-password page
    yield put(push('/'))
  }
}
